import * as actionType from './actions/workOrderAction';

const initialState = {
    list: [],
    message: '',
    modalOpen: false,
    loading: false,
    isWorkOrderEdit: false,
    isWorkOrderList: true,
    apiStatus: false,
    isCache : false,
    WorkRequestInfo1:{
        VendorDropdownDetails:[]
    },
    WorkRequestInfo:{
        StoreDetails:[]
    }


}

const workOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.WORK_ORDER_LIST:
            return { ...state, loading: false, modalOpen: false, isWorkOrderList: true, isWorkOrderEdit: false, message: "",  WorkRequestInfo: action.payload }
        case actionType.WORK_ORDER_LIST1:
            return { ...state, loading: false, modalOpen: false, isWorkOrderList: true, isWorkOrderEdit: false, message: "",  WorkRequestInfo1: action.payload }
        case actionType.API_CALL_STATUS:
            return { ...state, loading: action.payload.loading,apiStatus:action.payload.apiStatus, modalOpen: action.payload.modalOpen, message: action.payload.message}
        case actionType.IS_WORK_ORDER_LIST:
            return { ...state, modalOpen: false, loading: false,isWorkOrderEdit:false,isWorkOrderList:action.payload }  
        case actionType.LOAD_TICKET_HISTORY:
            return{ ...state,modalOpen:false, loading:false,isWorkOrderEdit:false, TicketHistory:action.payload}
        
        case actionType.SELECTED_DATA:
            return{ ...state,modalOpen:false, loading:false,isWorkOrderEdit:false, SelectedData:action.payload}
        case actionType.CLEAR_WORK_ORDER_STORE_INFO:
            return{...state,modalOpen: false, loading: false,isWorkOrderEdit:false,
            WorkRequestInfo:{
                WorkOrderStoreData:[],
                WorkOrderStoreDetails:[]
            },message:""}
        case actionType.COMING_FROM_QUOTATION:
            return {...state, isCache:action.payload}
            case actionType.CLEAR_MESSAGESS:
                return { ...state, modalOpen: false, loading: false,message:"" }                         
        default:
            return state
    }
}

export default workOrderReducer;